import axios from "axios";

export const SERVER_URL =
  process.env.NODE_ENV === "production"
    ? "https://loonlog.ca/api"
    : "http://localhost:5000";
export const WS_URL =
  process.env.NODE_ENV === "production"
    ? "https://loonlog.ca"
    : "http://localhost:5000";

export const FRONTEND_URL =
  process.env.NODE_ENV === "production"
    ? "https://loonlog.ca"
    : "http://localhost:3000";
// : "http://192.168.1.7:3000";

export const client = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true,
});

